export default __webpack_public_path__ + "images/89a8c0dfdbfbcda13f0ae0e80ad316fd-canoeing.webp";